const DomainVerification = (props) => {
  const meta = document.createElement("meta");
  meta.setAttribute("name", "facebook-domain-verification");
  meta.content = props.id;
  document.getElementsByTagName("head")[0].appendChild(meta);
  return null;
};

export default DomainVerification;
